import { useRef } from 'react';
import { Camera } from 'lucide-react';
import { Button } from './Button';

interface PhotoCaptureButtonProps {
  label: string;
  onCapture: (file: File) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * One-tap photo capture for mobile: opens the rear camera directly via
 * `capture="environment"`, falling back to the file picker on desktop.
 * why: kept apart from the `FileUpload` dropzone — a drag-and-drop area is the wrong
 * affordance for someone standing in a stairwell with a phone.
 */
export function PhotoCaptureButton({
  label,
  onCapture,
  disabled = false,
  className = '',
}: PhotoCaptureButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
        className={className}
      >
        <Camera className="w-3.5 h-3.5 mr-1" aria-hidden />
        {label}
      </Button>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          // Reset so picking the same file twice still fires a change event.
          e.target.value = '';
          if (file) onCapture(file);
        }}
      />
    </>
  );
}
